import { takeLatest, call, put } from 'redux-saga/effects'
import AllFolderList from 'api/courses/AllFolders'
import * as fromActions from '../../actions/courses.action'

async function getList() {
  return AllFolderList()
}

function* getCourseAllFoldersListEffectSaga() {
  try {
    const { dataAll } = yield call(getList)
    yield put(fromActions.Actions.coursesGetAllFoldersSuccess(dataAll))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* getCourseAllFoldersListWatcherSaga() {
  yield takeLatest(
    fromActions.COURSES_GET_ALL_FOLDERS,
    getCourseAllFoldersListEffectSaga
  )
}
